import React from 'react'

function Mint() {
  return (
    <>
    <main>
    <div className="chub-home container-fluid">
      <div className="row">
        <div className='col-sm-8 offset-sm-2' data-aos="fade-up" data-aos-duration="1000">
            <div className='mz-spacing'></div>
            <img src='assets/images/Mint-large.png' className="img-fluid mx-auto d-block" alt="Chub Mint" width={1119} height={1119}/>
        </div>
      </div>
    </div>
    </main>
    </>
  )
}

export default Mint